import styles from './RowSizePicker.module.scss';

import { ListItem, ListItemButton, ListItemText, Popover } from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RowSizeMode } from '../../../../../../../../../../settings/settings';
import { PickerTargetButton } from '../../../../../../../../locked-inputs';

const SIZES: RowSizeMode[] = ['SINGLE', 'AUTO'];

interface RowSizePickerTargetProps {
  value: RowSizeMode;
  setOpen: (open: boolean) => void;
}

interface RowSizePickerWrapperProps {
  onChange: (value: RowSizeMode) => void;
  target?: React.ReactElement;
  open: boolean;
  setOpen: (open: boolean) => void;
}

interface RowSizePickerProps {
  value: RowSizeMode;
  onChange: (value: RowSizeMode) => void;
}

export const RowSizePickerTarget = ({
  value,
  setOpen,
}: RowSizePickerTargetProps) => {
  const { t } = useTranslation();
  return (
    <PickerTargetButton
      className={styles.pickerSize}
      label={t('POSITIONS.ROW_SIZE.TOOLTIP')}
      value={t(`POSITIONS.ROW_SIZE.${value}`)}
      onClick={() => setOpen(true)}
    />
  );
};

export const RowSizePickerPopover = ({
  onChange,
  target,
  open,
  setOpen,
}: RowSizePickerWrapperProps) => {
  const { t } = useTranslation();

  const ref = useRef(null);

  const onClick = (action: RowSizeMode) => {
    setOpen(false);
    onChange(action);
  };

  return (
    <div ref={ref}>
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={ref.current}
        classes={{ paper: styles.root }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {SIZES.map((size) => (
          <ListItem key={size} disablePadding className={styles.pickerSize}>
            <ListItemButton
              className={styles.listItemButton}
              role={undefined}
              onClick={() => onClick(size)}
            >
              <ListItemText primary={t(`POSITIONS.ROW_SIZE.${size}`)} />
            </ListItemButton>
          </ListItem>
        ))}
      </Popover>
      {target}
    </div>
  );
};

export const RowSizePicker = ({ value, onChange }: RowSizePickerProps) => {
  const [open, setOpen] = useState(false);

  return (
    <RowSizePickerPopover
      onChange={onChange}
      open={open}
      setOpen={setOpen}
      target={<RowSizePickerTarget value={value} setOpen={setOpen} />}
    />
  );
};
